import { ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-background px-4">
      <div className="w-full max-w-md p-8 space-y-8 animate-in slide-in-from-bottom-4 duration-700">
        <div className="text-center space-y-6">
          <div className="space-y-2 flex flex-col items-center">
            <img
              src="/logo.png"
              alt="Prepsheets Logo"
              className="h-20 mx-auto"
            />
          </div>
        </div>
        {children}
        <div className="text-center mt-8">
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} - All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
